var letterSpacings = {
  sm: "-0.2px",
  xs: "-0.8px",
  xxs: "-1.2px"
};
export { letterSpacings as default };